// imports
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import Link from 'next/link';

// lib files
import { VideoTypeEnum } from '@/lib/types/api/video';

// components
import ITSImage from '@/components/ITSImage/ITSImage';
import WatchVideoButton from '@/components/WatchVideoButton/WatchVideoButton';

// styles
import styles from './MezzanineVideoInitializer.module.scss';

interface MezzanineVideoInitializerBaseProps {
  videoType?: VideoTypeEnum;
  imgSrc: string | null; // If no image is possible, intentionally pass null for handling
  alt: string;
  showWatchButton?: boolean;
  verticalOffsetButton: boolean;
  width: number;
  className?: string;
  sizes?: string;
  customButtonText?: string; // Override the default video type-based text
}
interface MezzanineVideoInitializerLinkProps extends MezzanineVideoInitializerBaseProps {
  href: string;
  onClick?: never;
  prefetch?: boolean;
}
interface MezzanineVideoInitializerClickHandlerProps extends MezzanineVideoInitializerBaseProps {
  href?: never;
  onClick: () => void;
  prefetch?: never;
}

type MezzanineVideoInitializerProps =
  MezzanineVideoInitializerLinkProps | MezzanineVideoInitializerClickHandlerProps;

const MezzanineVideoInitializer = (props: MezzanineVideoInitializerProps) => {
  const {
    videoType,
    showWatchButton = true,
    alt,
    onClick,
    href,
    prefetch = true,
    imgSrc,
    verticalOffsetButton,
    width,
    className,
    sizes,
    customButtonText
  } = props;

  const aspectRatio = 9 / 16; // 0.5625

  let listOfSizes = [320, 480, 768, 1024, 1280, 1440, 1700]

  // loop through list of sizes and remove those above width prop
  listOfSizes = listOfSizes.filter((size) => size <= width)

  // add width prop to list of sizes
  listOfSizes.push(width)

  // create array of tuples where each item is a pair of the size and the size times the aspect ratio
  const srcSetSizes: Array<[number, number]> = listOfSizes.map((size) => [size, (size * aspectRatio)!])

  let classNames = styles.mezzanine_video_initializer;

  if (className) {
    classNames += ` ${className}`;
  }

  // if no sizes prop is provided, assume full width up to max width
  const sizesToUse = sizes ? sizes : `
    (min-width: 1700px) 1700px,
    100vw
  `;

  const BackgroundElement = () => {
    if (imgSrc) {
      return (
        <ITSImage
          src={imgSrc}
          alt={alt}
          width={width}
          height={width * aspectRatio}
          srcSetSizes={srcSetSizes}
          sizes={sizesToUse}
          format="webp"
          loading="eager"
          fetchPriority="high"
          className={styles.mezzanine_video_initializer_image}
          />
      )
    } else if (imgSrc === null) {
      return (
        <div className={styles.mezzanine_video_initializer_placeholder}></div>
      )
    }
  }

  if (onClick) {
    return (
      <div className={classNames}>
        <BackgroundElement />
        { showWatchButton && (
          <WatchVideoButton
            videoType={videoType || VideoTypeEnum.Video}
            onClick={() => onClick()}
            verticalOffset={verticalOffsetButton}
            customButtonText={customButtonText}
          />
        )}
      </div>
    );
  } else if (href) {
    return (
      <Link className={classNames} href={href} prefetch={prefetch}>
        <BackgroundElement />
        { showWatchButton && (
          <WatchVideoButton
            videoType={videoType || VideoTypeEnum.Video}
            onClick={null}
            verticalOffset={verticalOffsetButton}
            customButtonText={customButtonText}
          />
        )}
      </Link>
    );
  }
}

export default MezzanineVideoInitializer;
